import { useTranslation } from 'react-i18next';
import { ChevronRight } from '@/design-system/icons';
import { useGlobalUserRoles } from '@/features/employees/hooks';
import type { UserCompanyContact } from '../api/user';

interface UserCompanyContactsListProps {
  contacts: UserCompanyContact[];
  onContactClick: (companyId: string, contactId: string) => void;
}

export function UserCompanyContactsList({
  contacts,
  onContactClick,
}: UserCompanyContactsListProps) {
  const { t } = useTranslation();

  // Translated role names from the shared global roles cache, keyed by role id.
  const { data: roles = [] } = useGlobalUserRoles();
  const roleNameById = new Map(roles.map((role) => [role.id, role.name]));

  if (contacts.length === 0) {
    return (
      <div className="py-6 text-center opacity-50 text-sm">
        {t('userProfile.noCompanyContacts')}
      </div>
    );
  }

  return (
    <div className="divide-y divide-border">
      {contacts.map((contact) => (
        <button
          key={contact.contactId}
          type="button"
          onClick={() => onContactClick(contact.companyId, contact.contactId)}
          className="w-full flex items-center justify-between py-3 px-2 hover:bg-surface-darker transition-colors text-left text-onbackground hover:text-onsurface"
        >
          <div className=''>
            <p className="text-sm font-medium">{contact.companyName}</p>
            <p className="text-xs opacity-50">{roleNameById.get(contact.roleId) ?? contact.roleName ?? contact.roleId}</p>
          </div>
          <ChevronRight className="w-4 h-4" />
        </button>
      ))}
    </div>
  );
}
